/*
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2022-09-02 13:55:11
 * @LastEditTime: 2023-10-09 12:10:29
 * @Description: 
 */
import http from './http'

export default {
    getUserEvent(cb, form) {
        http.post('/api/netzeroSystem/netzero/behaviorAnalysis', cb, form)
    },
    getTravelRecord(cb, request) {
        http.get('/api/netzeroSystem/cnt/getTravelRecord', cb, request)
    },
    getWelcome(cb, form) {
        http.post('/api/netzeroSystem/cnt/welcome/travelRecord', cb, form)
    },
    getLogin(cb, form) {
        http.post('/api/netzeroSystem/carbon/netzero/login', cb, form)
    },
    getConfig(cb, form) {
        http.post('/api/netzeroSystem/carbon/netzero/getConfiguration', cb, form)
    },
    getSnCode(cb, request) {
        http.get('/api/netzeroSystem/merchant/giftCard/sn', cb, request)
    },
    changePassword(cb, form) {
        http.post('/api/netzeroSystem/carbon/netzero/setUserInfo', cb, form)
    },
    getBurnt(cb, form) {
        http.post('/api/netzeroSystem/cnt/burnt/travelRecord', cb, form)
    },
    getExport(cb, form) {
        http.downloadPost('/api/netzeroSystem/cnt/certificate/export', cb, form)
    },
    getcalCarbonFootprint(cb, request) {
        http.post('/api/netzeroSystem/cnt/calCarbonFootprint', cb, request)
    },
    carbonFootPrint(cb, request) {
        http.post('/api/netzeroSystem/travelRecord/carbonFootPrint', cb, request)
    },
    computCarCon(cb, request) {
        http.post('/api/netzeroSystem/travelRecord/save', cb, request)
    },
    getCarConListNum(cb, request) {
        http.post('/api/netzeroSystem/travelRecord/list', cb, request)
    },
    changeneutralize(cb, request) {
        http.post('/api/netzeroSystem/travelRecord/carbonFootprint/neutralize', cb, request)
    },
    getuserInfo(cb, request) {
        http.post('/api/netzeroSystem/userInfo/all', cb, request)
    },
    getCarConNum(cb, request) {
        http.get('/api/netzeroSystem/travelRecord/totalCarbonFootPrint/' + request, cb)
    },
    getpdf(cb, request) {
        http.downloadPost('/api/netzeroSystem/carbon/netzero/downloadPdf', cb, request)
    },
    //调取第三方接口
    getFromTo(cb, request) {
        http.get('aps/arcgis/rest/services/World/GeocodeServer/suggest', cb, request)
    },
    getsubMit(cb, request) {
        http.post('/api/netzeroSystem/cnt/pending/travelRecord', cb, request)
    },
    getNftPrice(cb, request) {
        http.get('/api/netzeroSystem/cnt/nft/getNftPrice', cb, request)
    },

    getNftStatus(cb, request) {
        http.post('/api/netzeroSystem/cnt/nft/purchase/status', cb, request)
    },
    calDescription(cb, request) {
        http.get('/api/netzeroSystem/cnt/nft/calDescription', cb, request)
    },
    getBuyUrl(cb, request) {
        http.get('/api/netzeroSystem/cnt/nft/getBuyUrl', cb, request)
    },
    getOrder(cb, request) {
        http.get('/api/netzeroSystem/cnt/nft/stripe/order', cb, request)
    },
    getSendDoubtEmail(cb, request) {
        http.post('/api/netzeroSystem/netzero/sendCustomerServiceEmail', cb, request)
    },
    getFaqList(cb, request) {
        http.get('/api/netzeroSystem/faq/list', cb, request)
    },

}